import 'react-table/react-table.css';
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {debounce} from 'throttle-debounce';
import PropTypes from 'prop-types';
import moment from 'moment/min/moment-with-locales';
import {fetchClaimsHistoryPageData} from '../../../actions/claims/actionClaimsHistoryPage';
import Table from '../../common/table/TicketTable';
import historyMessages from '../../../intl/claims/historyMessages';

class HistoryClaimsTable extends Component {
    constructor(props) {
        super(props);
        this.state = this.loadStateFromSessionStorage({
            historyCLDefaultPageSize: 10,
            historyCLDefaultSort: [{id: 'TICKET_NUMBER', desc: true}],
            historyCLDefaultFilters: [],
        });
        this.filtering = false;
        this.handleFetchDataDebounced = debounce(1000, this.handleFetchData);
    }

    componentDidMount() {
        window.addEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
        this.saveStateToSessionStorage();
    }

    loadStateFromSessionStorage(defaults) {
        return Object.keys(defaults)
            .reduce((acc, key) => {
                if (sessionStorage.hasOwnProperty(key) && key.match(/^historyCL*/)) {
                    let value = sessionStorage.getItem(key);
                    value = JSON.parse(value);
                    return {
                        ...acc,
                        [key]: value,
                    };
                }
                return acc;
            }, defaults);
    }

    saveStateToSessionStorage = () => {
        for (let key in this.state) {
            if (this.state.hasOwnProperty(key) && key.match(/^historyCL*/)) {
                sessionStorage.setItem(key, JSON.stringify(this.state[key]));
            }
        }
    }

    handleFetchData = state => {
        this.props.fetchClaimsHistoryPageData(state.pageSize, state.sorted, state.cursor, state.isNextFromPivot, this.normalizeFiltered(state));
        this.filtering = false;
        this.setState({
            historyCLDefaultPageSize: state.pageSize,
            historyCLDefaultSort: state.sorted,
            historyCLDefaultFilters: state.filtered,
        });
    };

    fetchStrategy = (state) => {
        this.filtering ? this.handleFetchDataDebounced(state) : this.handleFetchData(state);
    };

    normalizeFiltered = state => {
        return state.filtered
            .filter(filterItem => filterItem.value)
            .map(filterItem => {
                if (filterItem.value instanceof Date || filterItem.id === 'ORDER_CREATION_TIME') {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value).add(12, 'hours').toISOString().substr(0, 10),
                    };
                } else {
                    return filterItem;
                }
            });
    };

    render() {
        const {columns, data, pages, isLoading, isNextPage, isNextFromPivot} = this.props;
        return (
            <div className="container-fluid text-center">
                <div className="row">
                    <div className="col">
                        <Table
                            columns={[
                                {
                                    id: 'TICKET_NUMBER',
                                    accessor: 'ticketNumber',
                                    message: historyMessages.TABLE_TICKET_NUMBER,
                                    Cell: row => <Link to={`view/${row.original.id}`}>{row.value}</Link>,
                                },
                                ...columns]}
                            isLoading={isLoading}
                            data={data}
                            pages={pages}
                            handleFetchData={this.fetchStrategy}
                            handleOnFilteredChange={() => {
                                this.filtering = true;
                            }}
                            isNextPage={isNextPage}
                            isNextFromPivot={isNextFromPivot}
                            defaultFiltered={this.state.historyCLDefaultFilters}
                            defaultSorting={this.state.historyCLDefaultSort}
                            defaultPageSize={this.state.historyCLDefaultPageSize}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

HistoryClaimsTable.propTypes = {
    columns: PropTypes.array,
};

const mapStateToProps = state => ({
    isLoading: state.claimsHistoryPage.isTableLoading,
    data: state.claimsHistoryPage.listData,
    isNextPage: state.claimsHistoryPage.isNextPage,
    isNextFromPivot: state.claimsHistoryPage.isNextFromPivot,
    pages: state.claimsHistoryPage.pages,
});

export default connect(mapStateToProps, {
    fetchClaimsHistoryPageData
})(HistoryClaimsTable);
